import { Feature } from '@/pinia/feature'
import { climateIndex } from './climateIndex'
import { temperature } from './temperature'
import { co2 } from './co2'
import { humidity } from './humidity'

export const indoorClimate: Feature = {
  name: 'indoorclimate',
  enabled: true,
  access: ['FEAT_INDOOR-CLIMATE_READER'],
  title: {
    en: 'Indoor climate',
    sv: 'Inomhus&shy;klimat'
  },
  component: 'DashboardFeature',
  isRoute: true,
  props: {
    icon: 'ThermometerIcon',
    defaultFilters: {
      calendar: {
        quickSelect: 'last7days'
      }
    }
  },
  children: [
    {
      name: 'filters',
      enabled: true,
      title: {
        en: 'Filters',
        sv: 'Filter'
      },
      component: 'IndoorClimateFilters'
    },
    {
      name: 'colorlegend',
      enabled: true,
      title: {
        en: 'Indoor climate',
        sv: 'Inomhusklimat'
      },
      component: 'ColorLegend',
      props: {
        width: 288,
        height: 64,
        type: 'continuous'
      }
    },
    {
      name: 'data',
      enabled: true,
      title: {
        en: 'Data',
        sv: 'Data'
      },
      children: [climateIndex, temperature, co2, humidity]
    }
  ]
}
